import * as ActionTypes from './EnumTypes/ActionEnumTypes';
import * as POIActionModel from './Models/POIActionModel';
import * as ViewManagementModule from './../../Modules/ViewManagementModule';
import * as POIModule from '../../Modules/POIModule';
import * as UserModel from './../../Models/UserModel';
import { reset, destroy } from 'redux-form';

function getPoiList(userId?: number, showSideLoader?: boolean) {
    return async dispatch => {
        try {
            if(showSideLoader) {
                dispatch(ViewManagementModule.Actions.showDetailsSidebarLoader());
            }
            const poiList = await POIModule.Connector.getPOIList(userId ? userId : null);
            dispatch(getPOISuccess(poiList.data.pointOfInterestList));

            if(showSideLoader) {
                dispatch(ViewManagementModule.Actions.hideDetailsSidebarLoader());
            }
        } catch (err) {
            dispatch(ViewManagementModule.Actions.hideDetailsSidebarLoader());
        }
    };
}

function addPoi(poiDetails: POIModule.Types.AddPointOfInterestRequest) {
    return async dispatch => {
        try {
            await POIModule.Connector.addPOI(poiDetails);
            dispatch(reset('addPoiForm'));

            dispatch(addPOISuccess());
            dispatch(getPoiList());
            dispatch(ViewManagementModule.Actions.hideAddingPOI());
            dispatch(destroy('addPoiForm'));
        } catch (err) {
            dispatch(addPOIFailure(err ? err.response.data : null));
        }
    };
}

function deletePoi(poiID: number) {
    return async dispatch => {
        try {
            await POIModule.Connector.deletePOI(poiID);
            dispatch(deletePOISuccess());
            dispatch(getPoiList());
        } catch (err) {
            dispatch(deletePOIFailure(err.response.data));
        }
    };
}
function updatePoi(poiData: POIModule.Types.UpdatePointOfinterestRequest, poiId: number) {
    return async dispatch => {
        try {
            await POIModule.Connector.updatePoi(poiData, poiId);
            dispatch(updatePoiSuccess());
            await dispatch(getPoiList());
            dispatch(hidePoiDetailsPopup());
        } catch (err) {
            dispatch(hidePoiDetailsPopup());
        }
    };
}
function updatePoiSuccess() {
    return {
        type: ActionTypes.POI.UPDATE_POI_SUCCESS
    };
}
function getPOISuccess(poiList: Array<POIModule.Types.PointOfInterestDto>): POIActionModel.GetPOISuccessAction {
    return {
        type: ActionTypes.POI.GET_POI_SUCCESS,
        payload: {
            poiList
        }
    };
}

function getPOIFailure(error: UserModel.Types.Error): POIActionModel.GetPOIFailureAction {
    return {
        type: ActionTypes.POI.GET_POI_FAILURE,
        payload: {
            error
        }
    };
}

function addPOISuccess(): POIActionModel.AddPOISuccessAction {
    return {
        type: ActionTypes.POI.ADD_POI_SUCCESS
    };
}

function addPOIFailure(error: UserModel.Types.Error): POIActionModel.ADDPOIFailureAction {
    return {
        type: ActionTypes.POI.ADD_POI_FAILURE,
        payload: {
            error
        }
    };
}

function deletePOISuccess(): POIActionModel.DeletePOISuccessAction {
    return {
        type: ActionTypes.POI.DELETE_POI_SUCCESS
    };
}
function addPoiPopupPosition(popupPosition: { lat: number; lng: number }): POIActionModel.AddPoiPopupPosition {
    return {
        type: ActionTypes.POI.ADD_POI_POPUP_POSITION,
        payload: {
            popupPosition
        }
    };
}

function deletePOIFailure(error: UserModel.Types.Error): POIActionModel.DeletePOIFailureAction {
    return {
        type: ActionTypes.POI.DELETE_POI_FAILURE,
        payload: {
            error
        }
    };
}
function setDetailsForPoiView(activePoi: POIModule.Types.PointOfInterestDto): POIActionModel.SetDetailsForPoiView {
    return {
        type: ActionTypes.POI.SET_DETAILS_FOR_POI_VIEW,
        payload: {
            activePoi
        }
    };
}
function togglePoiDetailsPopup(): POIActionModel.TogglePoiPopupManagement {
    return {
        type: ActionTypes.POI.POI_DETAILS_POPUP_TOGGLE
    };
}
function showPoiDetailsPopup(): POIActionModel.ShowPoiPopupManagement {
    return {
        type: ActionTypes.POI.POI_DETAILS_POPUP_SHOW
    };
}
function hidePoiDetailsPopup(): POIActionModel.HidePoiPopupManagement {
    return {
        type: ActionTypes.POI.POI_DETAILS_POPUP_HIDE
    };
}
export { getPoiList, addPoi, deletePoi, setDetailsForPoiView, showPoiDetailsPopup, hidePoiDetailsPopup, togglePoiDetailsPopup, addPoiPopupPosition, updatePoi };



// WEBPACK FOOTER //
// ./src/Redux/Actions/POIActions.ts